
<div class="ft-dialog-component-wrap">
  <div class="ft-modal-dialog modal-notify" 
  [ngClass]="{
      'modal-error': data.messageType === 'error' || (data.errorFunc && data.messageType !== 'warning'),
      'modal-warning': data.messageType === 'warning',
      'modal-success': data.messageType === 'success',
      'modal-info': data.messageType === 'info' || (!data.messageType && !data.errorFunc),
      'modal-ft-about-us': data.messageType === 'ft-about-us'
  }">
    @if (data.messageType !== 'ft-about-us') {
    <div class="ft-modal-header">
      @if (data.title) {
      <h2 class="heading" mat-dialog-title [innerHTML]="data.title"></h2>
      }
      @if ((data.errorFunc && data.messageType !== 'warning') || data.showCloseButton) {
      <button mat-icon-button 
                aria-label="close dialog" 
                class="dialog-close-button"
                (click)="closeDialog()"
                
                mat-dialog-close>
            <mat-icon>close</mat-icon>
      </button>
      }
    </div>
    }

    <mat-dialog-content class="mat-typography">
      @if (data.imageUrl) {
      <div class="dialog-image-container">
        <img [src]="data.imageUrl" [alt]="data.imageAlt" />
      </div>
      }
        
        <!-- Error content -->
      @if (data.messageType === 'error' || (data.errorFunc && data.messageType !== 'warning')) {
      <div class="message-content error-content">
            <mat-icon class="message-icon error-icon" aria-hidden="false" aria-label="Error">error</mat-icon>
            <div class="message-text" [innerHTML]="data.html"></div>
      </div>
      }
        
      <!-- Warning content -->
      @if (data.messageType === 'warning') {
      <div class="message-content warning-content">
            <mat-icon class="message-icon warning-icon" aria-hidden="false" aria-label="Warning">warning</mat-icon>
            <div class="message-text" [innerHTML]="data.html"></div>
      </div>
      }
        
      <!-- Success content -->
      @if (data.messageType === 'success') {
      <div class="message-content success-content">
            <mat-icon class="message-icon success-icon" aria-hidden="false" aria-label="Success">check_circle</mat-icon>
            <div class="message-text" [innerHTML]="data.html"></div>
      </div>
      }
        
      <!-- Info content -->
      @if (data.messageType === 'info') {
      <div class="message-content info-content">
            <mat-icon class="message-icon info-icon" aria-hidden="false" aria-label="Information">info</mat-icon>
            <div class="message-text" [innerHTML]="data.html"></div>
      </div>
      }
        
      <!-- About Us content -->
      @if (data.messageType === 'ft-about-us') {
      <div class="ft-dialog-data" [innerHTML]="data.html"></div>
      }
        
      <!-- Default content (no message type) -->
      @if (!data.messageType && !data.errorFunc && data.messageType !== 'warning' && data.messageType !== 'success' && data.messageType !== 'info' && data.messageType !== 'ft-about-us') {
      <div class="ft-dialog-data" [innerHTML]="data.html"></div>
      }
      @if (data.input) {
      <div>
        @if (data.input !== 'radio' && data.input !== 'checkbox' && data.input !== 'range') {
        <div>
          <mat-form-field>
            @if (data.inputPlaceholder) {
            <mat-label>{{ data.inputPlaceholder }}</mat-label>
            }
            @if (data.input === 'select') {
            <mat-select [(ngModel)]="inputValue">
              @for (option of data.inputOptions | keyvalue; track option) {
              <mat-option [value]="option.value">
              {{ option.value }}
              </mat-option>
              }
            </mat-select>
            } @else {
            <input [type]="data.input" matInput [(ngModel)]="inputValue" />
            }
          </mat-form-field>
        </div>
        }
        @if (data.input === 'radio') {
        <mat-radio-group [(ngModel)]="inputValue">
          @for (option of data.inputOptions | keyvalue; track option) {
          <mat-radio-button [value]="option.value">
            {{ option.value }}
          </mat-radio-button>
          }
        </mat-radio-group>
        }
        @if (data.input === 'checkbox') {
        <mat-checkbox [(ngModel)]="inputValue">{{ data.inputPlaceholder }}</mat-checkbox>
        }
        @if (data.input === 'range') {
        <div>
          <mat-slider
            class="dialog-range-slider"
            [(ngModel)]="inputValue"
            [min]="data.inputAttributes.min || 0"
            [max]="data.inputAttributes.max || 1"
            [step]="data.inputAttributes.step || 1"
            [value]="data.inputValue || 0"
          ></mat-slider>
          {{ inputValue }}
        </div>
        }
      </div>
      }
    </mat-dialog-content>

    <mat-dialog-actions class="ft-modal-footer" 
                        [ngClass]="{'warning-footer': data.messageType === 'warning'}" 
                        align="end">
      @if (data.confirmButton) {
      <button type="button" 
                mat-button 
                [color]="getButtonColor()" 
                (click)="ok()" 
                mat-raised-button
                cdkFocusInitial
                [mat-dialog-close]="data.inputValue">
            {{ data.confirmButtonText || 'OK' }}
      </button>
      }
      @if (data.succFunc && data.showConfirmButton !== false) {
      <button type="button" 
                mat-button 
                [color]="getButtonColor()" 
                (click)="ok()" 
                mat-raised-button
                class="ft-dialog-save"
                cdkFocusInitial>
            {{ data.confirmButtonText || 'OK'}}
      </button>
      }
      @if (data.discardFunc) {
      <button type="button" 
                mat-button 
                (click)="discard()" 
                color="warn" 
                class="ft-dialog-discard"
                mat-raised-button>
            Discard
      </button>
      }
      @if (data.errorFunc || data.messageType === 'warning') {
      <button type="button" 
                mat-button 
                class="ft-dialog-cancel"
                (click)="cancel()">
            {{ data.cancelButtonText || 'Cancel' }}
      </button>
      }
    </mat-dialog-actions>
  </div>
</div>